import { getFile } from '../../common/files/getFile';

// Backwards-compatible alias. New call sites should import `getFile` from
// `@commenda/api/common/files`.
export const getSalesTaxFile = getFile;
